import React from 'react';
import { Badge } from '../ui/Badge';
const upcomingFeatures = [{
  title: 'Badges numériques',
  description: "Badge personnalisé à l'inscription, PDF imprimable, photo + QR unique"
}, {
  title: 'QR Check-in sur site',
  description: 'Scan entrée, horodatage, vérification accès, aucune file'
}, {
  title: 'Sondages & Q&A en direct',
  description: 'Formulaires post-session automatiques, questions upvotées temps réel'
}, {
  title: 'Certificats participation',
  description: 'Générés automatiquement avec nom + événement + date, livrés email'
}];
export function ComingSoonSection() {
  return <section className="w-full py-20 md:py-24 relative font-heading" style={{
    backgroundColor: '#09090B'
  }} data-id="element-132">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="text-center mb-16" data-id="element-134">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-135">
            Ce qui arrive
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-136">
          {upcomingFeatures.map((feature, index) => <div key={index} className="bg-white/[0.02] border border-white/[0.05] rounded-xl p-8 flex flex-col items-start relative overflow-hidden group" data-id="element-137">
              {/* Subtle hover gradient */}
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500/[0.02] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-138" />

              <Badge className="mb-5 bg-orange-500/10 text-orange-400 border-orange-500/20 hover:bg-orange-500/20 px-3 py-1 text-xs font-mono uppercase tracking-wider rounded-full relative z-10" data-id="element-139">
                Prochainement
              </Badge>
              <h3 className="text-2xl font-semibold text-white mb-3 relative z-10" data-id="element-140">
                {feature.title}
              </h3>
              <p className="text-white/50 text-base leading-relaxed relative z-10" data-id="element-141">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}